import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/security/auth.service";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LoginIcon from '@mui/icons-material/Login';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import constants from "../../utils/constants";
import TokenService from "../../services/security/token.service";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href={constants.WEB}>
                Winvest
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const defaultTheme = createTheme();

export default function SignIn() {
    let navigate = useNavigate();
    const [dni, setDni] = useState('');
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({ dni: '', email: '', password: '', api: '' });
    const [load, setLoad] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        document.title = `wBroker`;
        //AuthService.logout();
    });

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }
    const isValidDni = (dni) => {
        return /^[0-9]+$/.test(dni);
    }

    const onValidateEmail = (e) => {
        if (e.target.value) {
            if (!isValidEmail(e.target.value)) {
                setErrors({ ...errors, email: 'El email es inválido' });
            }
        }
    };

    const onChangeDNI = (event) => {

        if (event.target.value !== '') {
            if (isValidDni(event.target.value)) {
                setDni(event.target.value);
            }
        } else {
            setDni(event.target.value);
        }
        setErrors({ ...errors, dni: event.target.value.trim() ? '' : 'DNI es obligatorio' });
    }

    const onChangeEmail = (event) => {
        setEmail(event.target.value);
        setErrors({ ...errors, email: event.target.value.trim() ? '' : 'Email es obligatorio' });
    };

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        setErrors({ ...errors, password: event.target.value.trim() ? '' : 'Contraseña es obligatoria' });
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    const handleLogin = () => {
        setLoad(true);

        let formErrors = {};

        if (!dni.trim()) {
            formErrors.dni = 'DNI es obligatorio';
        }
        if (!email.trim()) {
            formErrors.email = 'Email es obligatorio';
        } else {
            if (!isValidEmail(email)) {
                formErrors.email = 'El email es inválido';
            }
        }
        if (!password.trim()) {
            formErrors.password = 'Contraseña es obligatoria';
        }

        setErrors(formErrors);

        if (Object.keys(formErrors).length > 0) {
            setLoad(false);
            return;
        }

        AuthService.login(email, password, dni, constants.CLIENT).then(
            (response) => {
                try {
                    if (response.instances.length <= 1) {
                        if (response.instances[0].roles.length <= 1) {
                            let dataUser = TokenService.getUser();
                            dataUser.data = response.instances[0].roles[0];
                            dataUser.data.instance = response.instances[0].name;
                            TokenService.setUser(dataUser);
                            AuthService.addLogin(email, password, dni, constants.CLIENT, response.instances[0].roles[0].role, response.instances[0].name, response.instances[0].roles[0].entityId);
                            let landingPage = response.instances[0].roles[0].landingPage;
                            if (landingPage)
                                navigate(`/${landingPage}`);
                            else
                                navigate(`/home`);
                            //window.location.reload();
                            setLoad(false);
                        } else {
                            if (response.lastLogin !== null && response.lastLogin !== undefined) {
                                let dataUser = TokenService.getUser();
                                dataUser.data = response.lastLogin.role;
                                dataUser.data.instance = response.lastLogin.instance;
                                TokenService.setUser(dataUser);
                                AuthService.addLogin(email, password, dni, constants.CLIENT, response.lastLogin.role.role, response.lastLogin.instance, response.lastLogin.entityId);
                                let landingPage = response.lastLogin.role.landingPage;
                                if (landingPage)
                                    navigate(`/${landingPage}`);
                                else
                                    navigate(`/home`);
                                //window.location.reload();
                                setLoad(false);
                            } else {
                                const dataJson = JSON.stringify(response);
                                navigate(`/listlogin?data=${encodeURIComponent(dataJson)}`);
                                setLoad(false);
                            }
                        }
                    } else {
                        if (response.lastLogin !== null) {
                            let dataUser = TokenService.getUser();
                            dataUser.data = response.lastLogin.role;
                            dataUser.data.instance = response.lastLogin.instance;
                            TokenService.setUser(dataUser);
                            AuthService.addLogin(email, password, dni, constants.CLIENT, response.lastLogin.role.role, response.lastLogin.instance, response.lastLogin.entityId);
                            let landingPage = response.lastLogin.role.landingPage;
                            if (landingPage)
                                navigate(`/${landingPage}`);
                            else
                                navigate(`/home`);
                            //window.location.reload();
                            setLoad(false);
                        } else {
                            const dataJson = JSON.stringify(response);
                            navigate(`/listlogin?data=${encodeURIComponent(dataJson)}`);
                            setLoad(false);
                        }
                    }
                    setLoad(false);

                } catch (error) {
                    const dataJson = JSON.stringify(response);
                    navigate(`/listlogin?data=${encodeURIComponent(dataJson)}`);
                    setLoad(false);
                }

            },
            (error) => {

                setLoad(false);
                if (error.response) {
                    setErrors({ ...errors, api: error.response.data.message });
                } else {
                    setErrors({ ...errors, api: "Error de conexión con el servidor" });
                }
            }
        );
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'blue' }}>
                        <LoginIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Ingresá a tu cuenta
                    </Typography>

                    <TextField
                        autoComplete="dni"
                        name="dni"
                        required
                        fullWidth
                        id="dni"
                        label="DNI"
                        autoFocus
                        value={dni}
                        onChange={onChangeDNI}
                        error={!!errors.dni}
                        helperText={errors.dni}
                        onKeyDown={handleKeyDown}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        onChange={onChangeEmail}
                        onBlur={onValidateEmail}
                        value={email}
                        error={!!errors.email}
                        helperText={errors.email}
                        onKeyDown={handleKeyDown}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type={showPassword ? "text" : "password"}
                        id="password"
                        autoComplete="current-password"
                        onChange={onChangePassword}
                        value={password}
                        error={!!errors.password}
                        helperText={errors.password}
                        onKeyDown={handleKeyDown}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    {!load && (

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            onClick={handleLogin}
                        >
                            Iniciar Sesión
                        </Button>
                    )}
                    {load && (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress size={50} />
                        </div>
                    )}
                    {errors.api && (
                        <Typography variant="body2" color="error">
                            {errors.api}
                        </Typography>
                    )}
                    <Grid container>
                        <Grid item xs>
                            <Link href="/register" variant="body2">
                                ¿Primer ingreso?
                            </Link>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs>
                            <Link href="/reset" variant="body2">
                                ¿Olvidaste la contraseña?
                            </Link>
                        </Grid>
                    </Grid>

                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}